var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpiral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 681,
    height: 667,
    viewBox: "0 0 681 667",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.727 34.0727C225.673 37.5963 220.848 41.3508 216.252 45.3218C210.936 48.2612 205.745 51.4903 200.691 55.0138C198.109 56.8142 195.586 58.675 193.123 60.5941C162.605 64.0545 133.823 74.3179 108.497 91.9751C104.514 94.752 100.673 97.6723 96.9746 100.729C92.8268 103.143 88.7578 105.737 84.7743 108.514C31.3012 145.796 3.42784 208.933 1.53682 280.81C-0.354204 352.688 23.7317 433.343 74.2175 505.756C124.703 578.168 192.053 628.659 260.15 651.742C328.09 674.771 396.811 670.523 450.232 633.479C480.557 629.961 509.156 619.714 534.338 602.157C539.756 598.38 544.912 594.336 549.804 590.045C555.522 586.939 561.099 583.499 566.517 579.722C571.571 576.198 576.396 572.444 580.993 568.473C586.308 565.533 591.499 562.304 596.553 558.781C650.026 521.499 677.9 458.362 679.791 386.484C681.682 314.607 657.596 233.952 607.11 161.539C556.624 89.127 489.275 38.6354 421.178 15.5534C353.081 -7.52867 284.2 -3.20878 230.727 34.0727Z",
    stroke: "#A7E1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiral);
export default __webpack_public_path__ + "static/media/spiral.ba11cb65c2029c506d68df96da9fd99c.svg";
export { ForwardRef as ReactComponent };